@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

@form-padding: 15px;
@headerAndFooterHeight: 50px;

.form {
  background-color: @rate-browser-form--header--background-color;

  .header {
    display: flex;
    align-items: center;
    padding: @form-padding;
    border-bottom: 1px solid @rate-browser-modal-form--header--border-color;
    height: @headerAndFooterHeight;
    font-size: 18px;
  }

  .body {
    padding: (@form-padding * (2 / 3)) @form-padding;
    position: absolute;
    inset: @headerAndFooterHeight 0 @headerAndFooterHeight 0;
    overflow: auto;

    .section {
      width: 100%;
      margin-top: 20px;

      &:first-child {
        margin-top: 0;
      }

      .section-header {
        font-size: 16px;
        font-weight: @semi-bold;
        margin-bottom: 10px;

        &.error {
          color: @rate-browser-modal-form--body--error--text-color;
        }
      }

      .field {
        margin-top: 10px;

        &:first-child {
          margin-top: 0;
        }

        &.flex-row > * {
          margin-right: 5px;
        }

        .field-label {
          font-size: 15px;
          margin-bottom: 5px;
        }

        &.flex-row > .field-label {
          margin-bottom: 0;
        }
      }
    }
  }

  .footer {
    padding: @form-padding;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: @headerAndFooterHeight;
    border-top: 1px solid @rate-browser-modal-form--footer--border-color;
    background-color: @rate-browser-modal-form--footer--background-color;
  }

  .instructions {
    color: @rate-browser-modal-form--instructions--text-color;
    font-size: 12px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .clickable {
    cursor: pointer;
    user-select: none;
  }

  .text-input {
    height: 38px;
    font-size: 16px;
  }

  .has-error {
    border-color: @rate-browser-modal-form--input--error--border-color;
  }
}

.label-with-dropdown {
  justify-content: space-between;
  align-items: center;
}
